const toggleMenu = () => {
  const header = document.getElementById('js--header')
  const sidebar = document.getElementById('js--sidebar')
  const body = document.getElementById('js--body')
  const btn = document.getElementById('js--btn-menu')

  btn.addEventListener('click', (e) => {
    toggleClass()
  })

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && sidebar.classList.contains('js--active')) {
      toggleClass()
    }
  })

  toggleClass = () => {
    header.classList.toggle('js--active')
    sidebar.classList.toggle('js--active')
    btn.classList.toggle('js--active')
    body.classList.toggle('overflow-hidden')

    if (header.classList.contains('js--active')) {
      header.classList.add('theme--white')
      if (header.classList.contains('theme--trans')) {
        header.classList.remove('theme--trans')
      }

      if (header.classList.contains('theme--blue-oxford')) {
        header.classList.remove('theme--blue-oxford')
      }
    } else {
      header.classList.add(header.dataset.default)
      header.classList.remove('theme--white')
    }
  }
}

export default toggleMenu
